"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskTargetsContextProvider = exports.cellColorChoices = void 0;
var React = require("react");
var urls_1 = require("../../urls");
var matrixUtils_1 = require("../../components/admin/matrixUtils");
exports.cellColorChoices = matrixUtils_1.CellChoices.asChoices();
var initialState = {
    risk_targets: [],
    selectedRiskColor: matrixUtils_1.CellChoices.LOW,
    selectedOppColor: matrixUtils_1.CellChoices.LOW,
};
var RiskTargetsContext = React.createContext(__assign(__assign({}, initialState), { fetchRiskTargets: undefined, createRiskTarget: undefined, createMatrix: undefined, deleteRiskTarget: undefined, deleteMatrix: undefined, duplicateRiskTarget: undefined, onSaveRiskTarget: undefined, onChangeRiskTarget: undefined, onChangeMatrixConsequence: undefined, onChangeMatrixFrequency: undefined, onChangeMatrixCell: undefined, onChangeMatrix: undefined, onChangeColorSelector: undefined, onClickCell: undefined }));
exports.default = RiskTargetsContext;
var RiskTargetsContextProvider = (function (_super) {
    __extends(RiskTargetsContextProvider, _super);
    function RiskTargetsContextProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign({}, initialState);
        return _this;
    }
    RiskTargetsContextProvider.prototype.fetchRiskTargets = function () {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_risktargets, this.props.project_id), {
            type: "GET",
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success) {
                    self.setState({
                        risk_targets: response.results,
                    });
                }
            }
        });
    };
    RiskTargetsContextProvider.prototype.createRiskTarget = function () {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_create_risktarget, this.props.project_id), {
            type: "POST",
            data: {},
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success && response.created) {
                    self.setState(function (prev) { return ({
                        risk_targets: [response.created].concat(prev.risk_targets)
                    }); });
                }
            }
        });
    };
    RiskTargetsContextProvider.prototype.createMatrix = function (riskTarget, is_opportunity) {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_create_matrix, this.props.project_id, riskTarget.id), {
            type: "POST",
            data: JSON.stringify({
                is_opportunity: is_opportunity
            }),
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success && response.created) {
                    self.setState(function (prev) {
                        riskTarget.matrices = (riskTarget.matrices || []).concat([response.created]);
                        return {
                            risk_targets: prev.risk_targets,
                        };
                    });
                }
            }
        });
    };
    RiskTargetsContextProvider.prototype.deleteRiskTarget = function (riskTarget) {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_remove_risktarget, this.props.project_id, riskTarget.id), {
            type: "DELETE",
            complete: ajaxErrorHandler,
            success: function () {
                self.fetchRiskTargets();
            }
        });
    };
    RiskTargetsContextProvider.prototype.deleteMatrix = function (riskTarget, matrix) {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_remove_matrix, this.props.project_id, matrix.id), {
            type: "DELETE",
            complete: ajaxErrorHandler,
            success: function () {
                self.fetchRiskTargets();
            }
        });
    };
    RiskTargetsContextProvider.prototype.duplicateRiskTarget = function (riskTarget) {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_copy_riskarget, this.props.project_id, riskTarget.id), {
            type: "POST",
            complete: ajaxErrorHandler,
            success: function () {
                self.fetchRiskTargets();
            }
        });
    };
    RiskTargetsContextProvider.prototype.onSaveRiskTarget = function (riskTarget) {
        var newRiskTarget = __assign({}, riskTarget);
        newRiskTarget.matrices = riskTarget.matrices.map(function (matrix) {
            var newMatrix = (0, matrixUtils_1.deepCopyMatrix)(matrix);
            newMatrix.frequencies = newMatrix.frequencies.reverse();
            return newMatrix;
        });
        var self = this;
        var data = {
            risk_target: newRiskTarget,
        };
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_risktargets, this.props.project_id), {
            type: "POST",
            data: JSON.stringify(data),
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success) {
                    self.fetchRiskTargets();
                }
            }
        });
    };
    RiskTargetsContextProvider.prototype.renewState = function () {
        this.setState(function (prev) { return ({
            risk_targets: prev.risk_targets
        }); });
    };
    RiskTargetsContextProvider.prototype.onChangeRiskTarget = function (riskTarget, attr, value) {
        riskTarget[attr] = value;
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.onChangeMatrixConsequence = function (consequence, attr, value) {
        consequence[attr] = value;
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.onChangeMatrixFrequency = function (frequency, attr, value) {
        frequency[attr] = value;
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.onChangeMatrixCell = function (cell, attr, value) {
        cell[attr] = value;
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.onChangeMatrix = function (matrix, attr, value) {
        matrix[attr] = value;
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.onChangeColorSelector = function (color, is_opportunity) {
        if (is_opportunity)
            this.setState({ selectedOppColor: parseInt(color) });
        else
            this.setState({ selectedRiskColor: parseInt(color) });
    };
    RiskTargetsContextProvider.prototype.onClickCell = function (matrix, cell) {
        cell.color = matrix.is_opportunity ? this.state.selectedOppColor : this.state.selectedRiskColor;
        cell.color_display = matrixUtils_1.CellChoices.getColorDisplay(cell.color);
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.render = function () {
        return (React.createElement(RiskTargetsContext.Provider, { value: __assign(__assign({}, this.state), { fetchRiskTargets: this.fetchRiskTargets.bind(this), createRiskTarget: this.createRiskTarget.bind(this), createMatrix: this.createMatrix.bind(this), deleteRiskTarget: this.deleteRiskTarget.bind(this), deleteMatrix: this.deleteMatrix.bind(this), duplicateRiskTarget: this.duplicateRiskTarget.bind(this), onSaveRiskTarget: this.onSaveRiskTarget.bind(this), onChangeRiskTarget: this.onChangeRiskTarget.bind(this), onChangeMatrixConsequence: this.onChangeMatrixConsequence.bind(this), onChangeMatrixFrequency: this.onChangeMatrixFrequency.bind(this), onChangeMatrixCell: this.onChangeMatrixCell.bind(this), onChangeMatrix: this.onChangeMatrix.bind(this), onChangeColorSelector: this.onChangeColorSelector.bind(this), onClickCell: this.onClickCell.bind(this) }) }, this.props.children));
    };
    return RiskTargetsContextProvider;
}(React.Component));
exports.RiskTargetsContextProvider = RiskTargetsContextProvider;
